import styled from 'styled-components';
import { Alert, Collapse } from 'antd';

// Matches the PgaDisclaimAiStatus banner sizing so the recommendation card and
// the plain status banner are visually interchangeable in the PGA tab.
export const StyledAlert = styled(Alert)<{ $plainTitle?: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
  max-width: ${({ theme }) => theme.size.large};

  &.ant-alert-with-description {
    padding-top: ${({ theme }) => theme.spacing.space_3};
    padding-bottom: ${({ theme }) => theme.spacing.space_3};
  }

  .ant-alert-message {
    font-size: ${({ theme }) => theme.font.size.small};
    font-weight: ${({ $plainTitle }) => ($plainTitle ? 400 : 600)};
    margin-bottom: 0;
  }

  .ant-alert-description {
    font-size: ${({ theme }) => theme.font.size.xsmall};
    line-height: 1.4;
  }
`;

// Ghost collapse for the "Reasoning" disclosure shown under the recommendation.
export const ReasoningCollapse = styled(Collapse)<{ $bold?: boolean }>`
  &.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-header {
    padding: ${({ theme }) => theme.spacing.space_1} 0;
    font-weight: ${({ $bold }) => ($bold ? 600 : 400)};
  }
  &.ant-collapse-ghost
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0 0 ${({ theme }) => theme.spacing.space_2} 0;
  }
`;
